import { DateTime } from 'luxon'
import {
  ANODE,
  BLACK_MASS,
  CATHODE,
  LITHIUM,
  LITHIUM_ION_BATTERIES,
  NATURAL_GRAPHITE,
  SYNTHETIC_GRAPHITE,
} from '~/constants/services/constants'
import { fontStyleDefault } from '~/src/constants/download-xlsx-config'
import type { TGeneral } from '~/src/types/common'

export const getPurityHeader = (category?: string) => {
  let header = 'Purity'
  switch (category) {
    case BLACK_MASS.category:
      header = 'Product'
      break
    case LITHIUM_ION_BATTERIES.category:
      header = 'Format'
      break
  }
  return header
}

export const getPurityValue = (category?: string, item?: TGeneral) => {
  let purityValue = item.purity
  switch (category) {
    case BLACK_MASS.category:
      purityValue = item.product
      break
    case LITHIUM_ION_BATTERIES.category:
      purityValue = item.format
      break
  }
  return purityValue
}

export const cellObjectDate = (
  value?: string | Date,
  options: TGeneral = {},
  format = 'yyyy-MM-dd',
) => {
  const date =
    typeof value === 'string'
      ? DateTime.fromFormat(value, format)
      : DateTime.fromJSDate(value)
  return {
    f: `DATE(${date.year},${date.month},${date.day})`,
    z: 'dd mmm yyyy',
    s: {
      ...fontStyleDefault,
      ...options,
    },
  }
}

export const cellObjectNumber = (
  value?: string | number,
  format = '#,##0',
  options: TGeneral = {},
) => ({
  t: 'n',
  v: value,
  z: format,
  s: {
    ...fontStyleDefault,
    ...options,
  },
})

export const cellObjectTextBold = (value?: string, options: TGeneral = {}) => ({
  t: 's',
  v: value,
  s: {
    bold: true,
    ...fontStyleDefault,
    ...options,
  },
})

export const cellObjectText = (value?: string, options: TGeneral = {}) => ({
  t: 's',
  v: value,
  s: {
    ...fontStyleDefault,
    ...options,
  },
})

export const isLithium = (category?: string) => category === LITHIUM.category

export const isAnode = (category?: string) => category === ANODE.category

export const isCathode = (category?: string) => category === CATHODE.category

export const isNaturalGraphite = (category?: string) =>
  category === NATURAL_GRAPHITE.category

export const isLithiumIonBatteries = (category?: string) =>
  category === LITHIUM_ION_BATTERIES.category

export const isBlackMass = (category?: string) =>
  category === BLACK_MASS.category

export const isSyntheticGraphite = (category?: string) =>
  category === SYNTHETIC_GRAPHITE.category
